<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid>
      <div>
        <b-card header-tag="header">
          <template #header>
            <card-title>
              <b-icon class="icono" icon="file-text"></b-icon>Disponibilidad de
              cita grafico
            </card-title>
          </template>
          <b-card-body>
            <b-row class="text-center">
              <b-col sm="4">
                <div class="entradasreporte form-inline" style="display:flex;">
                  <label class="labelderecha" for="example-datepicker"
                    >Fecha inicial</label
                  >
                  <b-form-datepicker
                    id="example-datepicker"
                    locale="es-MX"
                    v-model="valueFechaInicial"
                    class="muevecalendario"
                    labelNoDateSelected="Escoga una fecha"
                    @click.native="actualizarFechaFinal()"
                  ></b-form-datepicker>
                </div>
              </b-col>
              <b-col sm="4">
                <div class="entradasreporte multipleselect">
                  <label class="labelmultiselect" for="clinica"
                    >Número de semanas</label
                  >
                  <div>
                    <b-form-select
                      id="semanas"
                      v-model="selectedSemanas"
                      :options="optionsSemanas"
                      size="sm"
                      class="mt-3"
                      @change="actualizarFechaFinal()"
                    ></b-form-select>
                    <div class="mt-3"></div>
                  </div>
                </div>
              </b-col>
              <b-col sm="4">
                <div class="entradasreporte form-inline">
                  <label class="labelderecha" for="region">Región</label>
                  <b-form-select
                    id="region"
                    v-model="selectedRegion"
                    :options="optionsRegion"
                    @change="obtenerClinicas(selectedRegion)"
                    size="sm"
                    class="mt-3"
                  ></b-form-select>
                  <div class="mt-3"></div>
                </div>
              </b-col>
            </b-row>
            <b-row class="text-center">
              <b-col sm="4">
                <div class="entradasreporte multipleselect">
                  <label class="labelmultiselect" for="clinica">Clínica</label>
                  <div>
                    <b-form-select
                      id="clinica"
                      v-model="selectedClinicas"
                      :options="optionsClinicas"
                      :disabled="deshabilitarClinicas"
                      @change="validacionesFormularioClinicaEspecialidad()"
                      multiple
                      :select-size="4"
                    ></b-form-select>
                    <div class="mt-3"></div>
                  </div>
                </div>
              </b-col>
              <b-col sm="4">
                <div class="entradasreporte multipleselect">
                  <label class="labelmultiselect" for="especialidades"
                    >Especialidades</label
                  >
                  <div>
                    <b-form-select
                      v-model="selectedEspecialidades"
                      :options="optionsEspecialidades"
                      @change="validacionesFormularioClinicaEspecialidad()"
                      multiple
                      :select-size="4"
                    ></b-form-select>
                    <div class="mt-3"></div>
                  </div>
                </div>
              </b-col>
              <b-col sm="4">
                <div class="entradasreporte form-inline" style="display:flex">
                  <label class="labelderecha" for="rangocita"
                    >Tipo de gráfica</label
                  >
                  <b-form-select
                    id="rangocita"
                    v-model="selectedRangocita"
                    :options="optionsRangocita"
                    size="sm"
                    class="mt-3"
                  ></b-form-select>
                  <div class="mt-3"></div>
                </div>
              </b-col>
            </b-row>
            <b-row class="text-center">
              <b-col sm="12">
                <b-button
                  v-on:click="obtenerDisponibilidadGrafico()"
                  class="entradasreporte botonesmargin"
                  variant="outline-primary"
                  >Ejecutar reporte</b-button
                >
              </b-col>
            </b-row>
            <div class="margingraficas">
              <canvas
                id="pordias"
                style="position: relative;width:1000px !important; height:500px !important; display:none ;"
              ></canvas>
            </div>

            <div class="margingraficas">
              <canvas
                id="porhoras"
                style="position: relative;  width:1000px !important; height:500px !important; display:none;"
              ></canvas>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </b-container>
  </div>
</template>

<script>
import ax from "axios";
import Header from "../../components/Header.vue";
import Chart from "chart.js";
import datosGraficaPorDias from "./graficaPorDias";
import datosGraficaPorHoras from "./graficaPorHoras";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  components: {
    Header,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    valueFechaInicial: "",
    valueFechaFinal: "",
    graficaHoras: "",
    graficaDias: "",
    datosGraficaPorDias: datosGraficaPorDias,
    datosGraficaPorHoras: datosGraficaPorHoras,
    selectedRegion: "",
    selectedSemanas: 1,
    selectedRangocita: "todas",
    optionsRegion: [],
    selectedEspecialidades: [0],
    selectedClinicas: [],
    selectedDoctor: [],
    optionsDoctores: [],
    optionsClinicas: [],
    graficaPorDiasBandera: false,
    graficaPorHorasBandera: false,
    deshabilitarClinicas: true,
    optionsEspecialidades: [],
    optionsRangocita: [
      { value: "todas", text: "TODAS" },
      { value: "dia", text: "POR DÍA" },
      { value: "horas", text: "POR HORA" },
    ],
    optionsSemanas: [
      { value: 1, text: "1 SEMANA" },
      { value: 2, text: "2 SEMANAS" },
      { value: 3, text: "3 SEMANAS" },
    ],
  }),
  methods: {
    createChart(chartId, chartData) {
      if (chartId == "porhoras") {
        const ctx = document.getElementById(chartId);
        this.graficaHoras = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
      } else if (chartId == "pordias") {
        const ctx = document.getElementById(chartId);
        this.graficaDias = new Chart(ctx, {
          type: chartData.type,
          data: chartData.data,
          options: chartData.options,
        });
      }
    },
    destroyChart() {
      this.graficaHoras.destroy();
      this.graficaDias.destroy();
    },
    showAlert() {
      Swal.fire({
        title: "Se esta ejecutando el reporte",
        html: "Espere por favor",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
    },
    validacionesFormulario: function() {
      if (this.selectedRegion == "") {
        this.deshabilitarClinicas = true;
        this.deshabilitarDoctor = true;
      } else {
        this.deshabilitarDoctor = false;
        this.deshabilitarClinicas = false;
      }
    },
    validacionesFormularioClinicaEspecialidad: function() {
      if (
        this.selectedClinicas.length > 1 &&
        (this.selectedEspecialidades.includes(0) ||
          this.selectedEspecialidades.length == 0)
      ) {
        Swal.fire({
          title: "Esta opción sólo está habilitada para reporte de 1 clínica",
          confirmButtonText: "Aceptar",
        });
        return false;
      } else {
        return true;
      }
    },
    validacionFecha() {
      if (this.valueFechaInicial == "" && this.valueFechaFinal == "") {
        Swal.fire({
          title: "Por favor selecciona la fecha inicial del reporte",
          confirmButtonText: "Aceptar",
        });
        return false;
      } else {
        return true;
      }
    },
    validacionesReporte: function() {
      if (
        this.selectedRegion == 0 &&
        (this.selectedEspecialidades.includes(0) ||
          this.selectedEspecialidades.length == 0 ||
          this.selectedEspecialidades.length > 1)
      ) {
        Swal.fire({
          title: "Esta opción esta deshabilitada por el momento",
          confirmButtonText: "Aceptar",
        });
        return false;
      } else {
        return true;
      }
    },
    obtenerDisponibilidadGrafico: function() {
      if (!this.validacionesReporte()) {
        return false;
      }
      if (!this.validacionFecha()) {
        return false;
      }

      if (!this.validacionesFormularioClinicaEspecialidad()) {
        return false;
      }

      this.showAlert();

      const _this = this;
      _this.items = [];
      let continuar = this.validacionesFormularioClinicaEspecialidad();
      if (continuar == false) {
        return false;
      }
      let temporalDoctor = [];
      let temporalClinica = _this.selectedClinicas;
      temporalDoctor = this.selectedDoctor;
      if (this.selectedDoctor == 0) {
        temporalDoctor = [];
      } else {
        temporalDoctor = [this.selectedDoctor];
      }
      if (_this.selectedEspecialidades.includes(0)) {
        _this.selectedEspecialidades = [];
      }
      try {
        this.destroyChart();
      } catch (error) {
        console.error("el error");
        console.error(error);
      }
      document.getElementById("porhoras").style.display = "none";
      document.getElementById("pordias").style.display = "none";

      if (_this.selectedRangocita == "todas") {
        this.graficaPorHorasBandera = false;
        this.graficaPorDiasBandera = false;
        this.obtenerDatosGraficaHoras(
          _this.valueFechaInicial,
          _this.valueFechaFinal,
          _this.selectedRegion,
          temporalClinica,
          _this.selectedEspecialidades,
          temporalDoctor
        );
        this.obtenerDatosGraficaDias(
          _this.valueFechaInicial,
          _this.valueFechaFinal,
          _this.selectedRegion,
          temporalClinica,
          _this.selectedEspecialidades,
          temporalDoctor
        );
      } else if (_this.selectedRangocita == "dia") {
        this.graficaPorHorasBandera = true;
        this.obtenerDatosGraficaDias(
          _this.valueFechaInicial,
          _this.valueFechaFinal,
          _this.selectedRegion,
          temporalClinica,
          _this.selectedEspecialidades,
          temporalDoctor
        );
      } else if (_this.selectedRangocita == "horas") {
        this.graficaPorDiasBandera = true;
        this.obtenerDatosGraficaHoras(
          _this.valueFechaInicial,
          _this.valueFechaFinal,
          _this.selectedRegion,
          temporalClinica,
          _this.selectedEspecialidades,
          temporalDoctor
        );
      }
    },
    obtenerDatosGraficaHoras(
      fechaInicial,
      fechaFinal,
      selectedRegion,
      selectedClinica,
      selectedEspecialidades,
      selectedDoctor
    ) {
      let region = document.getElementById("region");
      let textoRegion = region.options[region.selectedIndex].text;
      if (textoRegion == "TODAS") {
        textoRegion = "";
      }

      document.getElementById("porhoras").style.display = "block";
      let peticion =
        this.$apiUrl + "obtenerMatrizGraficoHoras" + this.$apiToken;
      let solicitud = {
        iniDate: fechaInicial,
        endDate: fechaFinal,
        cutTime: 60,
        zoneName: textoRegion,
        cliId: selectedClinica,
        docId: selectedDoctor,
        spcId: selectedEspecialidades,
      };
      ax.post(peticion, solicitud)
        .then((response) => {
          let arrayLabels = [];
          let arrayDisponibilidad = [];
          response.data.data.forEach(function(value) {
            arrayLabels.push(value.hora_ini + " a " + value.hora_fin);
            arrayDisponibilidad.push(value.porcentajedisponibilidad);
          });
          this.datosGraficaPorHoras.data.datasets[0].data = arrayDisponibilidad;
          this.datosGraficaPorHoras.data.labels = arrayLabels;
          this.createChart("porhoras", this.datosGraficaPorHoras);
          this.graficaPorHorasBandera = true;
          if (
            this.graficaPorDiasBandera == true &&
            this.graficaPorHorasBandera == true
          ) {
            Swal.close();
          }
        })
        .catch((error) => {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Oops... Hubo un error",
            text: "Por favor intentalo de nuevo!",
            // footer: "<a href>Why do I have this issue?</a>",
          });
          console.error("hubo error" + error);
        });
    },
    actualizarFechaFinal: function() {
      var momentInicial = moment(this.valueFechaInicial).format("YYYY-MM-DD");
      var momentFinal = moment(momentInicial)
        .add(this.selectedSemanas, "W")
        .format("YYYY-MM-DD");

      this.valueFechaFinal = momentFinal;
    },
    obtenerClinicas: function(region) {
      let params = { zonaId: [region] };
      let objetoClinicas = [];
      let peticion = this.$apiUrl + "/obtenerClinicas" + this.$apiToken;
      ax.get(peticion, { params: params })
        .then((response) => {
          response.data.data.forEach(function(value) {
            objetoClinicas.push({ value: value.cli_id, text: value.cli_name });
          });
          this.validacionesFormulario();
        })
        .catch();
      this.optionsClinicas = objetoClinicas;
    },
    obtenerZonas: function() {
      let peticion = this.$apiUrl + "/obtenerZonas" + this.$apiToken;
      let objetoZonas = [{ value: "", text: "TODAS" }];
      ax.get(peticion)
        .then((response) => {
          response.data.data.forEach(function(value) {
            objetoZonas.push({ value: value.zone_id, text: value.zone_name });
          });
          this.optionsRegion = objetoZonas;
        })
        .catch();
    },
    obtenerEspecialidades: function() {
      let peticion = this.$apiUrl + "/obtenerEspecialidades" + this.$apiToken;
      let objetoEspecialidades = [{ value: 0, text: "TODAS" }];
      ax.get(peticion)
        .then((response) => {
          response.data.data.forEach(function(value) {
            objetoEspecialidades.push({
              value: value.spc_id,
              text: value.spc_name,
            });
          });
          this.optionsEspecialidades = objetoEspecialidades;
        })
        .catch();
    },
    obtenerDatosGraficaDias(
      fechaInicial,
      fechaFinal,
      selectedRegion,
      selectedClinica,
      selectedEspecialidades,
      selectedDoctor
    ) {
      let region = document.getElementById("region");
      let textoRegion = region.options[region.selectedIndex].text;
      if (textoRegion == "TODAS") {
        textoRegion = "";
      }
      document.getElementById("pordias").style.display = "block";
      let peticion = this.$apiUrl + "obtenerMatrizGraficoDias" + this.$apiToken;
      let solicitud = {
        iniDate: fechaInicial,
        endDate: fechaFinal,
        cutTime: 60,
        zoneName: textoRegion,
        cliId: selectedClinica,
        docId: selectedDoctor,
        spcId: selectedEspecialidades,
      };
      ax.post(peticion, solicitud)
        .then((response) => {
          let arrayLabels = [];
          let arrayDisponibilidad = [];
          response.data.data.forEach(function(value) {
            arrayLabels.push(value.fecha);
            arrayDisponibilidad.push(value.porcentajedisponibilidad);
            moment(value.fecha, "YYYY-MM-DD").format("YYYY/MM/DD");
          });

          this.datosGraficaPorDias.data.datasets[0].data = arrayDisponibilidad;
          this.datosGraficaPorDias.data.labels = arrayLabels;
          this.createChart("pordias", this.datosGraficaPorDias);
          this.graficaPorDiasBandera = true;
          if (
            this.graficaPorDiasBandera == true &&
            this.graficaPorHorasBandera == true
          ) {
            Swal.close();
          }
        })
        .catch(() => {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Oops... Hubo un error",
            text: "Por favor intentalo de nuevo!",
          });
        });
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerZonas();
    this.obtenerEspecialidades();
  },

  computed: {},
  mounted() {
    this.obtenerClinicas([0]);
  },
};
</script>

<style scoped>
.template {
  width: 100%;
}

.headerTxt {
  font-weight: bold;
}

.SearchPti {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.bolderTxt {
  font-size: 14px;
  font-weight: bolder;
  width: 20%;
  margin-left: 15px;
}

#patientSelect {
  padding-left: 25px;
  padding-right: 25px;
}
.entradasreporte {
  padding: 10px;
}
.labelderecha {
  margin-right: 15px;
  margin-top: 10px;
}
.muevecalendario {
  margin-top: 15px;
}
.botonesmargin {
  margin: 20px;
}
.multipleselect {
  display: flex;
  align-items: flex-start;
}
.labelmultiselect {
  margin-top: 18px;
  margin-right: 15px;
}
.margingraficas {
  margin: 30px;
}
</style>
